// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"d37d356c","591":"139f8d4a"}[chunkId] + ".chunk.css";
};